/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Platform_About_HeadingInputs */

const en_platform_about_heading = /** @type {(inputs: Platform_About_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About the ${i?.name} API`)
};

const zh_hans1_platform_about_heading = /** @type {(inputs: Platform_About_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`关于 ${i?.name} API`)
};

const pt_br2_platform_about_heading = /** @type {(inputs: Platform_About_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sobre a API para ${i?.name}`)
};

const es_platform_about_heading = /** @type {(inputs: Platform_About_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acerca de la API de ${i?.name}`)
};

const fr_platform_about_heading = /** @type {(inputs: Platform_About_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`À propos de l’API ${i?.name}`)
};

const de_platform_about_heading = /** @type {(inputs: Platform_About_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Über die ${i?.name}-API`)
};

const ru_platform_about_heading = /** @type {(inputs: Platform_About_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Об API ${i?.name}`)
};

const it_platform_about_heading = /** @type {(inputs: Platform_About_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Informazioni sull'API di ${i?.name}`)
};

/**
* | output |
* | --- |
* | "About the {name} API" |
*
* @param {Platform_About_HeadingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_about_heading = /** @type {((inputs: Platform_About_HeadingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_About_HeadingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_about_heading(inputs)
	if (locale === "pt-BR") return pt_br2_platform_about_heading(inputs)
	if (locale === "es") return es_platform_about_heading(inputs)
	if (locale === "fr") return fr_platform_about_heading(inputs)
	if (locale === "de") return de_platform_about_heading(inputs)
	if (locale === "ru") return ru_platform_about_heading(inputs)
	if (locale === "it") return it_platform_about_heading(inputs)
	return en_platform_about_heading(inputs)
});